import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Link from 'gatsby-link';
import { theme, media } from 'styles';
import { iconFacebookSvg, iconInstagramSvg, iconLinkedinSvg } from 'images';
import { ProductCategoryType } from 'types';
import routes, { routeFor } from 'helpers/routes';
import Container from '../Container';

const FooterWrapper = styled.div`
  background-color: #43c6f4;
  background-image: radial-gradient(
    circle at bottom,
    rgba(255, 255, 255, 0.5) 0,
    #43c6f4 400px
  );
  padding-top: ${theme.sp.max};
  padding-bottom: ${theme.sp.max};
  line-height: 19px;
  font-size: 16px;
  font-weight: 600;

  ${props =>
    // props.isAddToCartVisible ? `margin-bottom: 126px;` : `margin-bottom: 0px;`};
    props.isAddToCartVisible ? `margin-bottom: 0px;` : `margin-bottom: 0px;`};

  ${media.tablet`
    ${props =>
      props.isAddToCartVisible
        ? // ? `margin-bottom: 87px;`
          `margin-bottom: 0px;`
        : `margin-bottom: 0px;`};
  `};
`;

const FooterContainer = styled(Container)`
  ${media.tablet`
    display: flex;
    justify-content: space-between;
  `};
`;

const Links = styled.div`
  a {
    display: block;
    margin-bottom: ${theme.sp.m};
    text-decoration: none;
    color: ${theme.colors.white};
    font-weight: 600;
  }
`;

const SubLink = styled(Link)`
  margin-bottom: ${theme.sp.m};
  opacity: 0.7;
`;

const PrimaryLinksWrapper = styled.div`
  display: flex;
  margin-bottom: 100px;
`;

const PrimaryLinksColumn = styled.div`
  ${media.tablet`
    display: flex;
    margin-bottom: 100px;
  `};
`;

const ServiceLinks = styled.div`
  position: relative;
  margin-right: ${theme.sp.max};
`;

const SiteLinks = styled.div`
  position: relative;

  ${media.tablet`
    margin-right: ${theme.sp.max};
  `};
`;

const SecondaryLinks = styled.div`
  text-align: center;

  ${media.tablet`
    text-align: left;
  `};

  a {
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 0;
    margin-left: 10px;
    font-weight: 400;
    font-size: 14px;

    ${media.tablet`
      margin-right: 20px;
      margin-left: 0;
    `};
  }
`;

const SocialIcons = styled.div`
  position: relative;
  margin-top: ${theme.sp.xl};
  text-align: center;

  ${media.tablet`
      margin-top: 0;
      text-align: right;
  `};

  a {
    display: inline-block;
    margin-right: ${theme.sp.m};
    margin-left: ${theme.sp.m};

    ${media.tablet`
      margin-right: 0;
      margin-left: ${theme.sp.xl};
  `};
  }
`;

/* const SubscriptionForm = styled.div`
  margin-bottom: 20px;
`; */

const Footer = props => (
  <FooterWrapper isAddToCartVisible={props.isAddToCartVisible}>
    {/* <SubscriptionForm>
      <iframe
        title="Active Campaign"
        src="https://markettap58913.activehosted.com/f/3"
        width="100%"
        height="580"
        type="text/html"
        frameBorder="0"
        allowTransparency="true"
        style={{ border: 0 }}
      />
    </SubscriptionForm> */}
    <FooterContainer>
      <Links>
        <PrimaryLinksWrapper>
          <ServiceLinks>
            <Link to="/">Shop Services</Link>
            {props.productCategories.map(pc => (
              <SubLink
                key={pc.id}
                to={routeFor(routes.products.category, pc.slug)}
              >
                {pc.name}
              </SubLink>
            ))}
          </ServiceLinks>

          <PrimaryLinksColumn>
            <SiteLinks>
              <Link to="/who-we-are">About</Link>
              <SubLink to="/who-we-are">Who We Are</SubLink>
              <SubLink to="/how-it-works">How It Works</SubLink>
            </SiteLinks>

            <SiteLinks>
              <Link to="/work">Our Work</Link>
              <Link to="/tapd-in">Tap&#39;d In</Link>
            </SiteLinks>
          </PrimaryLinksColumn>
        </PrimaryLinksWrapper>

        <SecondaryLinks>
          <Link to="/terms-and-conditions">Terms and Conditions</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/contact-us">Contact</Link>
        </SecondaryLinks>
      </Links>
      <SocialIcons>
        <a
          href="https://www.facebook.com/markettapd/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={iconFacebookSvg} alt="Facebook" />
        </a>
        <a
          href="https://www.instagram.com/markettapd/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={iconInstagramSvg} alt="Instagram" />
        </a>
        <a
          href="https://www.linkedin.com/company/markettap/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={iconLinkedinSvg} alt="LinkedIn" />
        </a>
      </SocialIcons>
    </FooterContainer>
  </FooterWrapper>
);

const propTypes = {
  productCategories: PropTypes.arrayOf(ProductCategoryType).isRequired,
  isAddToCartVisible: PropTypes.bool.isRequired,
};

Footer.propTypes = propTypes;

const mapStateToProps = state => ({
  isAddToCartVisible: state.ui.isAddToCartVisible,
});

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/shared/Footer/Footer.jsx